export const APPOINTMENT_LABEL = 'Appointment may be required to visit';
export const HOURS_VARY_LABEL = 'Hours may vary seasonally';
export const PERMANENTLY_CLOSED_LABEL = 'Permanently closed';
export const APPOINTMENT_FIELD_LABEL = 'Appointment required to visit';
export const PERMANENTLY_CLOSED_DESCRIPTION = 'Hides this place from search.';
export const HOURS_VARY_DESCRIPTION = 'Shows a caution note to visitors.';
export const APPOINTMENT_DESCRIPTION = 'Shows a booking note to visitors.';
export const TEMPORARY_CLOSURES_LABEL = 'Temporary closures';
export const TEMPORARY_CLOSURES_DESCRIPTION =
  'Dates this place is closed on top of its regular hours.';
export const PERMANENTLY_CLOSED_MODAL_BODY =
  'Are you positive this place is closed for good? It will no longer be available when searching Boone.';
export const EDIT_DATE_FORMAT = 'YYYY-MM-DD';
export const VIEW_DATE_FORMAT = 'MMMM D, YYYY';
